import * as React from 'react';
require('./style.css');

interface IProps {
	action: () => void;
	text: string;
}

const AddEntityItemCard = ({ text, action }: IProps) => (
	<div className="productItemCard commonItemCard wrapperAddItem">
		<div className="addItem">
			<div
				className="insideCard"
				onClick={(e) => {
					e.preventDefault();
					action();
				}}
			>
				<img src={`${require('containers/Html/images/AddItem.svg')}`} className="plusCircleImg" />
				<span className="title">{text}</span>
			</div>
		</div>
	</div>
);

export { AddEntityItemCard };
